// test674
(674 && 0);
